import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { FDStack } from '@facet-wealth/design';
import { HouseholdMemberList } from 'Components/ComponentLibrary/Organisms/HouseholdMemberList/HouseholdMemberList';
import { ManageHouseholdMember } from 'Views/Page/Content/Templates/ProfilePage/ManageHouseholdMember/ManageHouseholdMember';
import useMobileLayout from 'Hooks/useMobileLayout';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import {
  AddHouseholdMember,
} from 'Views/Page/Content/Templates/ProfilePage/ManageHouseholdMember/AddHouseholdMember';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { navigateToPage } from 'Views/Page/Content/Templates';


export const ManageHouseholdMembers = ({
  membersCollection,
  refreshMembers,
  addMemberRelationship,
}) => {
  const isMobile = useMobileLayout();
  const [newMember, setNewMember] = useState(null);
  const { loadPageContentLink, refreshPageContentCollection, setPageContentCollection } = usePageContentContext();
  const { displayErrorMessage } = useSnackbarContext();

  const onDeleteMember = (_) => {
    refreshMembers();
  };

  const onClick = async (resource) => {
    try {
      const relationship = resource.withRelationship(fr.relationships.profilePage.name,
        (rel) => rel, () => null);
      await loadPageContentLink(relationship.link('related'));
    } catch (err) {
      displayErrorMessage('Unable to add new household member');
    }
  };

  const defaultSelectMember = async () => {
    const memberToSelect = membersCollection.resources().head();
    try {
      const profilePageCollection = await memberToSelect.withRelationship(fr.relationships.profilePage.name,
        (rel) => rel.link('related').get(), () => null);
      setPageContentCollection(profilePageCollection);
    } catch (err) {
      // I'm not convinced we should actually do anything in this error case?
    }
  };

  useEffect(() => {
    const preSelectedMember = membersCollection.resources().list().find((member) => member.attr('isSelected') === 'true');
    // If we are in desktop we always want to pre-select a member from the list if one is not already selected
    if (!isMobile && !preSelectedMember) {
      defaultSelectMember();
    }
  }, [membersCollection]);

  const selectedMember = membersCollection.resources().list().find((member) => member.attr('isSelected') === 'true');

  const onClickAdd = () => {
    const newMemberResource = membersCollection.create();
    setNewMember(newMemberResource);
  };

  const onCloseNewMemberModal = () => {
    setNewMember(null);
  };

  return (
    <FDStack alignItems={'stretch'}>
      <HouseholdMemberList
        onClick={onClick}
        collection={membersCollection}
        onAddMember={() => onClickAdd()}
        addMemberRelationship={addMemberRelationship}
        selectedMember={selectedMember}
      />
      <ManageHouseholdMember
        resource={selectedMember}
        onDeleteMember={onDeleteMember}
        onSubmitSuccess={(res) => {
          refreshPageContentCollection();
          return res;
        }}
      />
      {newMember ? <AddHouseholdMember
        resource={newMember}
        isOpen={!!newMember}
        onCloseModal={onCloseNewMemberModal}
        onSubmitSuccess={(res) => {
          res?.withRelationship(
            fr.relationships.profilePage.name,
            (rel) => {
              if (!isMobile) {
                navigateToPage(rel.link('related').url(), false, {}, true);
              }
              if (isMobile) {
                refreshPageContentCollection();
              }
            },
            refreshPageContentCollection,
          );
        }}
      />
        : null}
    </FDStack>
  );
};

ManageHouseholdMembers.defaultProps = {
  addMemberRelationship: null,
};

ManageHouseholdMembers.propTypes = {
  membersCollection: PropTypes.instanceOf(fr.Collection).isRequired,
  refreshMembers: PropTypes.func.isRequired,
  addMemberRelationship: PropTypes.object,
};
